import { render, staticRenderFns } from "./MemberProfileCard.vue?vue&type=template&id=1aa47f36&scoped=true"
import script from "./MemberProfileCard.vue?vue&type=script&lang=js"
export * from "./MemberProfileCard.vue?vue&type=script&lang=js"
import style0 from "./MemberProfileCard.vue?vue&type=style&index=0&id=1aa47f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa47f36",
  null
  
)

export default component.exports